<div class="row">
    <div class="col-lg-12">
      <div class="card card-outline-success">
          <div class="card-header">
              <div style="float: left; position: relative; width: 70%; border-collapse: collapse; text-align: left">
                  <h4 class="m-b-0 text-white">Solicitudes de apoyo</h4>
              </div>
          </div>
          <div class="card-body" id="padre">
              <!-- ========================= -->
              <!-- ===== Orden tabla ===== -->
              <!-- ========================= -->
              <div>
                      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                          <thead>
                              <tr style="text-align: center">
                                  <th>Id</th>
                                  <th>Obra</th>
                                  <th>Estatus</th>
                                  <th>Sucursal</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let apoyo of arrayApoyosSolicitados" style="text-align: center" (click)="apoyoSolicitado(apoyo)">
                                  <td>{{ apoyo.ordenTrabajoId }}</td>
                                  <td>{{ apoyo.obra }}</td>
                                  <td> <span class="label" [style.background]="apoyo.estatusDos.color">  {{ apoyo.estatusDos.nombre }} </span></td>
                                  <td>{{ apoyo.sucursalNombre }}</td>
                              </tr>
                          </tbody>
                      </table>
              </div>
              <!-- ========================= -->
              <!-- ===== Orden tabla ===== -->
              <!-- ========================= -->
          </div>
      </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/listar-orden-pendiente-apoyo/listar-orden-pendiente-apoyo.component.html